import { useInitData } from './useInitData'

export function useUk() {
  return useInitData().uk
}
